import React from 'react';
import Card from '../components/Card';

const BuyerDashboard = () => {
  return (
    <div>
      <h2>Buyer Portal</h2>
      <Card title="Browse Produce" content="Browse available produce, request quotes, make purchases, and rate farmers." />
      {/* Add dynamic content here */}
    </div>
  );
};

export default BuyerDashboard;
